import { Collection } from '@ts/shopify-storefront-api';
import { normalizeSingleCollection } from '@utils/normalizers';
import { CleanedCollection } from '@ts/product';
import { DEFAULT_BASE_FRAME_SHAPE, LOCALE_CODES, LOCALE_DICT, MAX_PRODUCTS_TO_SEND } from '@constants';
import fetchStorefrontApi from '../fetch-storefront-api';
import { singleCollectionQuery } from '../queries';
import { cleanGraphqlResponse } from '..';

const getPaginatedCollection = async (handle: string, cursor: string, locale = LOCALE_CODES.US) => {
	const { countryCode: country, languageCode: language } = LOCALE_DICT[locale];
	const graphQlResponse: { collection: Collection } = await fetchStorefrontApi(singleCollectionQuery, {
		variables: {
			handle,
			cursor,
			withProducts: true,
			skipVariants: false,
			maxProducts: MAX_PRODUCTS_TO_SEND,
			includeDescription: false,
			includeSpecificFrameVariant: false,
			selectedOptions: [{ name: 'Frame', value: DEFAULT_BASE_FRAME_SHAPE }],
			skipCollections: true,
			skipImages: true,
			country,
			language,
		},
	});

	const paginationInfo = graphQlResponse.collection.products.pageInfo;
	const cleanedData = cleanGraphqlResponse(graphQlResponse);
	const normalizedData = normalizeSingleCollection((cleanedData as { collection: CleanedCollection }).collection);

	return {
		page: normalizedData,
		cursor: paginationInfo.hasNextPage ? paginationInfo.endCursor : null,
	};
};

export default getPaginatedCollection;
